import { login, logout, refreshToken } from '@repo/api';
import { runWithDedup } from '../utils';
import { createSlice } from '../factory';
export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        data: null,
        user: null,
        token: null,
    },
    actions: ({ get, setSlice }) => ({
        login: async (credentials) => {
            const apiLogin = login;
            const key = 'auth.login';
            const exec = async () => runWithDedup(key, () => apiLogin(credentials));
            const loading = get()?.loading;
            const response = loading?.withLoading ? await loading.withLoading(key, exec) : await exec();
            setSlice((prev) => ({
                ...prev,
                user: response.user,
                token: response.token,
                data: response.user,
            }));
        },
        logout: async () => {
            const apiLogout = logout;
            const key = 'auth.logout';
            const exec = async () => runWithDedup(key, () => apiLogout());
            const loading = get()?.loading;
            if (loading?.withLoading) {
                await loading.withLoading(key, exec);
            }
            else {
                await exec();
            }
            // Centralized reset of auth state only (namespaced)
            setSlice({ data: null, user: null, token: null });
        },
        refreshToken: async () => {
            const currentToken = get()?.auth?.token ?? get().token;
            if (!currentToken)
                throw new Error('No refresh token available');
            const apiRefresh = refreshToken;
            const key = 'auth.refreshToken';
            const exec = async () => runWithDedup(key, () => apiRefresh(currentToken));
            const loading = get()?.loading;
            const response = loading?.withLoading ? await loading.withLoading(key, exec) : await exec();
            setSlice((prev) => ({ ...prev, token: response.token }));
        },
        updateProfile: async (data) => {
            const currentUser = get()?.auth?.user ?? get().user;
            if (!currentUser)
                throw new Error('No authenticated user');
            // optimistic update
            setSlice((prev) => ({ user: { ...prev.user, ...data } }));
            try {
                const { updateUserProfile } = await import('@repo/api');
                const apiData = {};
                if (data.name !== undefined)
                    apiData.name = data.name;
                if (data.email !== undefined)
                    apiData.email = data.email;
                if (data.avatar !== undefined)
                    apiData.avatar = data.avatar;
                const key = 'auth.updateProfile';
                const exec = async () => runWithDedup(key, () => updateUserProfile(currentUser.id, apiData));
                const loading = get()?.loading;
                const apiResult = loading?.withLoading
                    ? await loading.withLoading(key, exec)
                    : await exec();
                const updated = {
                    ...apiResult,
                    role: data.role || currentUser.role,
                };
                setSlice((prev) => ({ user: updated, data: updated }));
            }
            catch (err) {
                // rollback
                setSlice({ user: currentUser });
                throw err;
            }
        },
    }),
});
// Consumers and factory can import `authSlice` directly (it includes name + build)
